module.exports = __webpack_public_path__ + "static/media/dst.5cac53ab.png";